import { USER_FEATURE_ACCESS_CACHE_EXPIRY_TIME } from "../constants/cacheExpirtyConstants";
import { getUserFeatureAccessTable } from "../database";
import type { Features } from "owa-graph-schema";
import { clearExpiredCache, isCacheValid } from "../utils";
import { logGreyError } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

/**
 * Retrieves cached user feature access data for the specified ownerId, ensuring expired entries
 * are cleaned up beforehand and the retrieved data is validated for freshness.
 */
export async function getCachedUserFeatureAccess(ownerId: string): Promise<(Features | null)[] | undefined> {
    clearExpiredCache(getUserFeatureAccessTable(), ownerId, USER_FEATURE_ACCESS_CACHE_EXPIRY_TIME).catch(error => {
        logGreyError("PlacesAnalytics_ClearUserFeatureAccessIDBCache_Error", getModuleContextMailboxInfo(), error);
    });
    
    // Retrieve and validate cache
    const cachedData = await getUserFeatureAccessTable().get(ownerId);
    if (cachedData && isCacheValid(cachedData.timestamp, USER_FEATURE_ACCESS_CACHE_EXPIRY_TIME)) {
        return cachedData?.featureAccess;
    }
    
    return undefined;
}
